import Head from 'next/head'

interface UnscoredCategoryPageSeoProps {
    description: string
    title: string
}

const UnscoredCategoryPageSeo = ({
    title,
    description,
}: UnscoredCategoryPageSeoProps) => {
    const formattedTitle = `${title} | TotallyMoney`

    return (
        <Head>
            <title>{formattedTitle}</title>

            <meta name="description" content={description} />

            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'Organization',
                        name: 'TotallyMoney',
                        url: 'https://totallymoney.com',
                        logo: 'https://www.totallymoney.com/favicon-32x32.png',
                        sameAs: [
                            'https://www.facebook.com/totallymoney',
                            'https://twitter.com/totallymoney',
                            'https://uk.linkedin.com/company/totallymoney',
                            'https://www.tiktok.com/@totallymoney',
                            'https://www.instagram.com/totallymoney/',
                            'https://www.youtube.com/channel/UCzT81m3neFD3QSqEwX0IAyg',
                        ],
                    }),
                }}
            />
        </Head>
    )
}

export default UnscoredCategoryPageSeo
